// extracted by mini-css-extract-plugin
export default {"wrap":"Sq-z","melodyCategory":"Tq-z","fullWidth":"Uq-z","items":"Vq-z","featureCss":"Wq-z","disabled":"Xq-z","imgCss":"Yq-z"};